/* ============================================================
   フォームの送信まわりの世話をする

   ① ボット対策の値を入れる（隠しフィールドに時刻）
   ② 送信ボタンの二重押しを止める
   ③ サーバーに弾かれて戻ってきたとき、入力内容を戻す

   ①のサーバー側（mail-form.jp の _lib/mailer.php）の判定
     - fsj_hp が埋まっていたらボットとみなす
     - fsj_ts から3秒未満の送信を機械とみなす
   JSが動かない環境では fsj_ts が空になるが、
   サーバー側は「0なら判定しない」ので送信は通る（人を締め出さない）。
   ============================================================ */
(function () {
  "use strict";

  /* 🚨 以前は form[action*="mail-form.jp"] で探していた。
        **送信先の文字列に依存していた**ため、action が変わるとガードが黙って外れ、
        二重送信の防止も入力の復元も消える。しかも fsj_ts が空になるだけで
        送信自体は通る（サーバーは0なら判定しない）ので、**誰も気づけない。**

        目印はフォーム自身のマークアップに置く。この隠し項目はフォームの一部なので、
        送信先が変わっても、Shopifyへ移しても、一緒に付いてくる。 */
  var stamp = document.querySelector('input[name="fsj_ts"]');
  var form  = stamp && stamp.form;
  if (!form) return;

  /* ---------- ① ボット対策の時刻 ---------- */
  var now = String(Math.floor(Date.now() / 1000));
  Array.prototype.forEach.call(
    form.querySelectorAll('input[name="fsj_ts"]'),
    function (f) { f.value = now; }
  );

  /* ---------- ③ 入力内容の一時保存 ----------
     サーバーに弾かれて戻されると、フォームは空になる。
     長文を書いた人が最初から書き直しになるのを防ぐ。

     ・保存先は sessionStorage＝**このタブの中だけ**。タブを閉じれば消える
     ・?error= が付いていないときは、開いた時点で消す
     ・戻したらすぐ消す
     ・ファイル欄は保存しない（できないし、すべきでもない）
     ・30分で失効
     プライベートブラウジング等で使えないことがあるので、必ず try で囲む */
  var KEY = "lp:form:" + window.location.pathname;
  var MAX_AGE = 30 * 60 * 1000;

  function store() { try { return window.sessionStorage; } catch (e) { return null; } }
  function drop() { var s = store(); if (s) { try { s.removeItem(KEY); } catch (e) {} } }

  function skip(el) {
    return !el.name
      || el.type === "file" || el.type === "submit"
      || el.type === "button" || el.type === "reset"
      || el.name === "fsj_ts" || el.name === "fsj_hp"
      /* reCAPTCHAのトークンは復元しない。古いトークンを戻すと弾かれる */
      || el.name === "g-recaptcha-response" || el.name === "recaptcha_mode";
  }

  function snapshot() {
    var s = store(); if (!s) return;
    var d = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (skip(el)) { d.push(null); return; }
      d.push((el.type === "checkbox" || el.type === "radio") ? el.checked : el.value);
    });
    try { s.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }

  function restore() {
    var s = store(); if (!s) return;
    var raw; try { raw = s.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    drop();                                   /* 読んだら即消す */
    var box; try { box = JSON.parse(raw); } catch (e) { return; }
    if (!box || !box.d || (Date.now() - box.t) > MAX_AGE) return;
    if (box.d.length !== form.elements.length) return;   /* ページが変わっていたら戻さない */
    Array.prototype.forEach.call(form.elements, function (el, i) {
      var v = box.d[i];
      if (v === null || skip(el)) return;
      if (el.type === "checkbox" || el.type === "radio") el.checked = !!v;
      else el.value = v;
    });
  }

  if (/[?&]error=/.test(window.location.search)) restore();
  else drop();

  /* ---------- ② 二重押しを止める ----------
     添付ありのフォームは送信に数秒かかる。反応が無いともう一度押され、
     2通目はレート制限に当たって「送れなかった」と誤解される。
     novalidate を外してあるので、submit は**検証を通った時だけ**発火する。 */
  var btn = form.querySelector('button[type="submit"], input[type="submit"]');
  var label = btn ? (btn.textContent || btn.value) : "";

  form.addEventListener("submit", function (e) {
    /* 画像調整中などで他のハンドラが送信を止めることがある。
       止められていたら、押せる状態のままにしておく
       （ここを見ないと、調整中に一度押しただけで二度と送信できなくなる） */
    window.setTimeout(function () {
      if (!btn || e.defaultPrevented) return;
      btn.disabled = true;
      if ("textContent" in btn && btn.tagName === "BUTTON") btn.textContent = "送信中…";
      else btn.value = "送信中…";
    }, 0);
    if (!e.defaultPrevented) snapshot();
  });

  /* 「戻る」で復帰したときにボタンが押せないままにならないようにする */
  window.addEventListener("pageshow", function () {
    if (!btn) return;
    btn.disabled = false;
    if (btn.tagName === "BUTTON") btn.textContent = label;
    else btn.value = label;
  });
})();
